import { getData, postData } from '@/services/api.service';
import React, { useEffect, useState } from 'react';
import { theme_5 } from '@/utils/constants';
import { useNavigate } from 'react-router';
import { routes } from '@/utils/routes/routes';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';
import { Spinner } from 'react-bootstrap';
import HomeEditBanner from './homeEditBanner';
import HomeEditBannerModal from './homeEditBannerModal';
import HomeEditBannerModalOne from './homeEditBannerModalOne';
import HomeEditBannerModalThree from './homeEditBannerModalThree';
import HomeEditBannerModalTwo from './homeEditBannerModalTwo';
import HomeEditBannerOne from './homeEditBannerOne';
import HomeEditBannerThree from './homeEditBannerThree';
import HomeEditBannerTwo from './homeEditBannerTwo';
import Header5 from '@/feature-module/common/header/header-5';
import Header5EditModal from '@/feature-module/common/header/edit/modals/header5-edit-modal';
import HomeEditBannerOurServices from './homeEditBannerOurServices';
import HomeEditBannerOurServicesModal from './homeEditBannerOurServicesModal';
import HomeEditBannerDownloadApp from './HomeEditBannerDownloadApp';
import HomeEditBannerDownloadAppModal from './HomeEditBannerDownloadAppModal';

const Home5Edit = ({ themeData, fetchData }: any) => {
  const navigate = useNavigate();

  return (
    <>
      {' '}
      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#headerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <>
          <Header5 themeData={themeData} />
        </>
      </div>
      <div
        className="modal fade"
        id="headerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <Header5EditModal themeData={themeData} fetchData={fetchData} />
      </div> */}
      {/* {window.location.href.includes('edit') && (
        <>
          <div className="row theme-editor">
            <div className="col-md-11 valign-center">
              <h6 className="m-0 text-white">Theme Editor</h6>
            </div>
            <div className="col-md-1">
              <a
                className="btn btn-danger"
                onClick={() => navigate(routes.home)}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
          <div className="mb-5"></div>
        </>
      )} */}
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#sectionBannerEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBanner themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="sectionBannerEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerModal themeData={themeData} getThemeData={fetchData} />
      </div>
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#sectionBannerOurServicesEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBannerOurServices themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="sectionBannerOurServicesEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerOurServicesModal themeData={themeData} getThemeData={fetchData} />
      </div>
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#sectiononeEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBannerOne themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="sectiononeEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerModalOne theme_5={themeData} getThemeData={fetchData} />
      </div>
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#section6Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBannerTwo themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="section6Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerModalTwo theme_5={themeData} getThemeData={fetchData} />
      </div>
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#section7Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBannerThree themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="section7Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerModalThree theme_5={themeData} getThemeData={fetchData} />
      </div>
      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#section8Editmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HomeEditBannerDownloadApp themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="section8Editmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HomeEditBannerDownloadAppModal theme_5={themeData} getThemeData={fetchData} />
      </div>
    </>
  );
};

export default Home5Edit;
